import React from "react";
import * as Icons from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "store/auth";

export default function MainMenu() {
  const location = useLocation();
  const [activeMenu] = location.pathname.slice(1).split("/");
  const auth = useAuth();
  return (
    <>
      <nav className="top-nav">
        <ul>
          {auth.userMeta &&
            auth.userMeta.panel_menus &&
            auth.userMeta.panel_menus.length > 0 &&
            auth.userMeta.panel_menus.map((item) => (
              <>
                {item.allow && (
                  <li>
                    <Link
                      to={item.to}
                      className={`top-menu ${
                        activeMenu == item.to.slice(1).split("/")
                          ? "top-menu--active"
                          : ""
                      }`}
                    >
                      <div className="top-menu__icon ">
                        <IconLoader name={item.icon} />
                      </div>
                      <div className="top-menu__title  text-white">
                        {item.title}
                        {item.notification_count > 0 && (
                          <span
                            style={{
                              display: "block",
                              borderRadius: "100%",
                              backgroundColor: "red",
                              fontSize: 12,
                              padding: 3,
                              margin: 3,
                              color: "white",
                            }}
                          >
                            {item.notification_count}
                          </span>
                        )}
                        {item.childs.length > 0 && (
                          <Icons.ChevronDown className="top-menu__sub-icon" />
                        )}
                      </div>
                    </Link>
                    <ul className="">
                      {item.childs &&
                        item.childs.length > 0 &&
                        item.childs.map((c_item) => (
                          <>
                            {c_item.allow && (
                              <li>
                                <Link to={c_item.to} className="top-menu">
                                  <div className="top-menu__icon !text-white">
                                    <IconLoader name={c_item.icon} />
                                  </div>
                                  <div className="top-menu__title !text-white">
                                    {" "}
                                    {c_item.title}
                                    {c_item.notification_count > 0 && (
                                      <span
                                        style={{
                                          display: "block",
                                          borderRadius: "100%",
                                          backgroundColor: "red",
                                          fontSize: 12,
                                          padding: 3,
                                          margin: 3,
                                          color: "white",
                                        }}
                                      >
                                        {c_item.notification_count}
                                      </span>
                                    )}
                                  </div>
                                </Link>
                              </li>
                            )}
                          </>
                        ))}
                    </ul>
                  </li>
                )}
              </>
            ))}
        </ul>
      </nav>
    </>
  );
}

const IconLoader = (props) => {
  const Dicn = Icons[props.name];
  return <Dicn {...props.rest} />;
};
